import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../components/header_ouvid';
import Head from '../../components/head';
import Footer from '../../components/footer';
import '../../styles/header.scss';

function OuvidoriaScreen() {
    return (
        <Fragment>
            <Head titulo="Como pedir uma informação - E-SIC" />
            <Header />
            <Container>
                <h4 style={{ textAlign: 'center' }}>Informações do SIC</h4>
                <br />
                <h6>UNIDADE/SETOR RESPONSÁVEL</h6>
                <p>Secretaria Municipal de Controle Interno</p>
                <br />
                <br />
                <h5>ATRIBUIÇÕES DA AUTORIDADE DE MONITORAMENTO DA LAI DO SIC</h5><br />
                <p>Assegurar o cumprimento das normas relativas ao acesso à informação, de forma eficiente e adequada aos objetivos da Lei nº 12.527, de 18 de novembro de 2011, Lei de Acesso à Informação (LAI)</p>
                <p>Monitorar a implementação da Lei nº 12.527, de 18 de novembro de 2011, Lei de Acesso à Informação (LAI) e apresentar relatórios periódicos sobre o seu cumprimento</p>
                <p>Recomendar as medidas indispensáveis à implementação e ao aperfeiçoamento das normas e procedimentos necessários ao correto cumprimento do disposto da Lei nº 12.527, de 18 de novembro de 2011, Lei de Acesso à Informação (LAI) e</p>
                <p>Orientar as respectivas unidades no que se refere ao cumprimento do disposto da Lei nº 12.527, de 18 de novembro de 2011, Lei de Acesso à Informação (LAI) e seus regulamentos.</p><br />
                <h5>COMPETÊNCIAS DA AUTORIDADE DE MONITORAMENTO DA LAI DO SIC</h5><br />
                <p>Definir meios e plataformas de implantação ou adequação da Lei nº 12.527, de 18 de novembro de 2011, Lei de Acesso à Informação (LAI)</p>
                <p>Garantir a transparência, dando cumprimento ao disposto na Lei nº 12.527, de 18 de novembro de 2011, Lei de Acesso à Informação (LAI)</p>
                <p>Monitorar os prazos e procedimentos das solicitações de acesso à informação, conforme disposto na Lei nº 12.527, de 18 de novembro de 2011, Lei de Acesso à Informação (LAI)</p>
                <p>Acompanhar, controlar e promover melhorias quanto à qualidade das plataformas de acesso à informação, sejam físicas ou eletrõnicas, em conformidade com a Lei nº 12.527, de 18 de novembro de 2011, Lei de Acesso à Informação (LAI) e</p>
                <p>Manifestar-se sobre relatos que expressam a omissão de autoridade competente no atendimento das solicitações de acesso à informação, conforme disposto na Lei nº 12.527, de 18 de novembro de 2011, Lei de Acesso à Informação (LAI).</p>
                <br />
                <h5>Prazos de resposta ao cidadão</h5><br />
                <table>
                    <thead>
                        <tr>
                            <th>Descrição</th>
                            <th>Trâmite</th>
                            <th>Prazo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>PRAZO PARA RESPOSTA</td>
                            <td>SIC AO REQUERENTE</td>
                            <td>20 DIAS</td>
                        </tr>
                        <tr>
                            <td>PRAZO PARA PRORROGAÇÃO</td>
                            <td>ORGÃO AO SIC</td>
                            <td>10 DIAS</td>
                        </tr>
                        <tr>
                            <td>PRAZO PARA ABERTURA DE RECURSO</td>
                            <td>REQUERENTE AO SIC</td>
                            <td>10 DIAS</td>
                        </tr>
                        <tr>
                            <td>PRAZO PARA TRATAMENTO DO RECURSO</td>
                            <td>AUTORIDADE DO RECURSO AO REQUERENTE</td>
                            <td>5 DIAS</td>
                        </tr>
                    </tbody>
                </table>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OuvidoriaScreen;